module.exports = __webpack_public_path__ + "img/9.dc7b5780.svg";